import { useMemo } from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { useBibliographyEntries } from "@/store/editorSelectors";
import { formatBibliographyEntry } from "@/lib/bibtex-parser";
import styles from "../blocks/blocks.module.scss";

export function BibliographyNodeView({ node, selected }: NodeViewProps) {
  const title = (node.attrs.title as string) || "References";
  const style = (node.attrs.style as "apa" | "mla" | "chicago") || "apa";
  const entries = useBibliographyEntries();

  const sortedEntries = useMemo(() => {
    return [...entries].sort((a, b) => {
      const authorA = a.fields.author || "";
      const authorB = b.fields.author || "";
      return authorA.localeCompare(authorB);
    });
  }, [entries]);

  return (
    <NodeViewWrapper data-type="bibliography-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div className={styles.bibliographyBlock}>
        <h2 className={styles.bibliographyTitle}>{title}</h2>
        {sortedEntries.length > 0 ? (
          <ol className={styles.bibliographyList}>
            {sortedEntries.map((entry) => (
              <li key={entry.id} className={styles.bibliographyEntry}>
                <span className={styles.bibliographyCiteKey}>[{entry.citeKey}]</span>
                <span
                  className={styles.bibliographyText}
                  dangerouslySetInnerHTML={{
                    __html: formatBibliographyEntry(
                      { ...entry, rawBibtex: undefined },
                      style
                    ),
                  }}
                />
              </li>
            ))}
          </ol>
        ) : (
          <p className={styles.bibliographyEmpty}>
            No citations in this document. Add citations using the sidebar.
          </p>
        )}
      </div>
    </NodeViewWrapper>
  );
}
